if (!customElements.get('info-drawer')) {
  customElements.define(
    'info-drawer',
    class InfoDrawer extends HTMLElement {
      constructor() {
        super();
        this.contentLoaded = false;

        this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());

        const overlay = this.querySelector('[data-info-drawer-overlay]');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));

        const closeButton = this.querySelector('[data-info-drawer-close]');
        if (closeButton) closeButton.addEventListener('click', this.close.bind(this));
      }

      open(triggeredBy) {
        this.activeElement = triggeredBy;
        this.loadContent();

        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        this.addEventListener(
          'transitionend',
          () => {
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(this, focusElement);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      loadContent() {
        if (this.contentLoaded) return;

        const url = this.dataset.url;
        const contentElement = this.querySelector('[data-info-drawer-contents]');
        if (!url || !contentElement) return;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((text) => {
            const main = new DOMParser().parseFromString(text, 'text/html').getElementById('MainContent');
            if (!main) throw new Error('MainContent not found');
            main.querySelectorAll('script').forEach((script) => script.remove());
            contentElement.innerHTML = main.innerHTML;
            this.contentLoaded = true;
          })
          .catch(() => {
            contentElement.innerHTML =
              '<p class="info-drawer__error">Diese Information konnte nicht geladen werden. <a href="' +
              url +
              '" class="link">Hier öffnen</a></p>';
          });
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-info-drawer-target]');
  if (!trigger) return;

  const drawer = document.getElementById(trigger.dataset.infoDrawerTarget);
  if (!drawer || typeof drawer.open !== 'function') return;

  event.preventDefault();
  drawer.open(trigger);
});
